<template>
    <section>Saindo....</section>
</template>

<script>
    export default {
        mounted() {
            this.$store.dispatch('logout')
            this.$router.push({name: 'login'});
        }
    }
</script>